import { render, staticRenderFns } from "./GlobientItemInfo.vue?vue&type=template&id=ba4d2d0a&"
import script from "./GlobientItemInfo.vue?vue&type=script&lang=js&"
export * from "./GlobientItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./GlobientItemInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports